var ERROR_STATUS_REALM_SETUP = {
    403: {
        code: 403,
        error_message: "",
    },
    401: {
        code: 401,
        error_message: "",
    },
};
export { ERROR_STATUS_REALM_SETUP };
